import { notification } from 'antd'
import apiClient from '../index'

export const getTrainees = ({ skip, limit, status, trainingStatus }) =>
  apiClient.get('/trainees', {
    params: {
      skip,
      limit,
      status,
      trainingStatus,
    },
  })

export const updateTraineeStatus = async (data) => {
  try {
    return await apiClient.patch('trainees', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getTraineeById = (id) => apiClient.get(`/trainees/${id}`)
